<div class="sidebar menu-sidebar" [class.menu-collapsed]='menu.menuCollapsed()'>

	<ul class="nav nav-sidebar flex-column flex-nowrap menu-scrollbar">

		@for(item1 of menu.menuItems();track $index){
		@if(item1.separator){
		<hr class='menu-separator'>
		}

		<li class="sidebar-list-item sidebar-item-expandable" [attr.data-url]='item1.routerLink'  [class.sidebar-item-expanded]="isExpanded(item1)">

			@if(!item1.subMenu){

			@if(!item1.routerLink){
			<a [attr.href]="item1.url || ''" [attr.target]="item1.target || ''" (mouseenter)="hoverItem($event)" (mouseleave)="unHoverItem()" class="sidebar-list-link">
				<i class="fa-fw {{ item1.icon }}"></i>
				<span>
					{{item1.label}}
				</span>
			</a>
			}
			@else {
			<a [routerLink]="[item1.routerLink]" (click)="collapseMenu($event)" (mouseenter)="hoverItem($event)" (mouseleave)="unHoverItem()" class="sidebar-list-link"  [class.active-link]="isActiveMenu(item1)">
				<i class="fa-fw {{ item1.icon }}"></i>
				<span>
					{{item1.label}}
				</span>
			</a>
			}
			}

			@if(item1.subMenu){

			<a [attr.href]="''" (click)="collapseMenu($event)" (mouseenter)="hoverItem($event)" (mouseleave)="unHoverItem()" class="sidebar-list-link">
				<i class="fa-fw {{ item1.icon }}"></i>
				<span class='sidebar-item-expanded-text'>
					{{item1.label}}
				</span>
				<span class='sidebar-item-collapsed-text'>
					{{item1.label_collapsed || item1.label}}
				</span>
				<b class="fa-regular fa-angle-down"></b>
			</a>

			<ul class="sidebar-sublist">
				@for (item2 of item1.subMenu; track $index) {
				<li class="sidebar-sublist-item sidebar-item-expandable" [attr.data-url]='item2.routerLink' [class.sidebar-item-expanded]="isExpanded(item2)">

					@if(item2.subMenu){
					<a [attr.href]="''" (click)="collapseMenu($event)" (mouseenter)="hoverItem($event)" (mouseleave)="unHoverItem()" class="sidebar-list-link subitem-submenu-link">
						<i class="{{ item2.icon }}"></i>
						<span>
							{{item2.label}}
						</span>
						<b class="fa-regular fa-angle-down"></b>
					</a>

					<ul class="sidebar-sublist subitem-submenu-list">
						@for (item3 of item2.subMenu; track $index) {
						<li (mouseenter)="hoverItem($event)" (mouseleave)="unHoverItem()">
							@if(!item3.routerLink){
							<a (mouseenter)="hoverItem($event)" (mouseleave)="unHoverItem()" [attr.href]="item3.url || ''" [attr.target]="item3.target || ''">
								<i class="{{ item3.icon }}"></i>
								{{item3.label}}
							</a>
							}
							@else{
							<a (mouseenter)="hoverItem($event)" (mouseleave)="unHoverItem()" [attr.target]="item3.target || ''" [routerLink]="[item3.routerLink]" [class.active-link]="isActiveMenu(item3)">
								<i class="{{ item3.icon }}"></i>
								{{item3.label}}
							</a>
							}
						</li>
						}
					</ul>
					}

					@else{
					@if(item2.routerLink){
					<a [routerLink]="[item2.routerLink]" (click)="collapseMenu($event)" (mouseenter)="hoverItem($event)" (mouseleave)="unHoverItem()"  [class.active-link]="isActiveMenu(item2)">
						<i class="{{ item2.icon }}"></i>
						<span>
							{{item2.label}}
						</span>
					</a>
					}
					@else{
					<a [attr.href]="item2.url || ''" [attr.target]="item2.target || ''" (mouseenter)="hoverItem($event)" (mouseleave)="unHoverItem()">
						<i class="{{ item2.icon }}"></i>
						<span>
							{{item2.label}}
						</span>
					</a>
					}
					}
				</li>
				}
			</ul>
			}
		</li>

		}

	</ul>

	<div class="sidebar-hover-elem" [ngStyle]="{top: hoverElemTop + 'px', height: hoverElemHeight + 'px'}" [ngClass]="{'show-hover-elem': showHoverElem }"></div>

</div>